import { render, staticRenderFns } from "./ClinicStatsManage.vue?vue&type=template&id=7591fe87&scoped=true"
import script from "./ClinicStatsManage.vue?vue&type=script&lang=js"
export * from "./ClinicStatsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7591fe87",
  null
  
)

export default component.exports